export const searchOptions = state => state.search.options;
export const searchOptionCities = state => state.search.options.cities;
export const searchOptionCategories = state => state.search.options.categories;
export const searchOptionAreas = state => state.search.options.areas;
export const searchOptionTags = state => state.search.options.tags;
export const searchOptionPriceTerm = state => state.search.options.priceTerm;
export const searchOptionBrands = state => state.search.options.brands;
